import Collaborators from "./Collaborators/Collaborators";
import Education from "./Education/Education";
import Experiences from "./Experiences/Experiences";
import Grants from "./Grants/Grants";
import Honors from "./Honors/Honors";
import Publications from "./Publications/Publications";
import Summary from "./Summary/Summary";
import Videos from "./Videos/Videos";
export const contentList = [
  {
    label: "Summary",
    component: Summary,
    path: `/admin/my-profile/summary`,
  },
  {
    label: "Video presentations",
    component: Videos,
    path: `/admin/my-profile/videos`,
  },
  {
    label: "Publications",
    component: Publications,
    path: `/admin/my-profile/publications`,
  },
  {
    label: "Grants",
    component: Grants,
    path: `/admin/my-profile/grants`,
  },
  {
    label: "Honors",
    component: Honors,
    path: `/admin/my-profile/honors`,
  },
  {
    label: "Experiences",
    component: Experiences,
    path: `/admin/my-profile/experiences`,
  },
  {
    label: "Education",
    component: Education,
    path: `/admin/my-profile/education`,
  },
  {
    label: "Collaborators",
    component: Collaborators,
    path: `/admin/my-profile/collaborators`,
  },
];
